
export default function DealerNameHeader({ name }) {
  return(
    <div className="sticky text-center z-30 pb-2 lg:pb-3 px-2 rounded-t">
      <div className="font-black text-2xl mt-1 pl-2 lg:pl-2">{name}</div>
    </div>
  )
}